import { render, staticRenderFns } from "./YGA.vue?vue&type=template&id=3397f949&"
import script from "./YGA.vue?vue&type=script&lang=js&"
export * from "./YGA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports